import { render, staticRenderFns } from "./AreaGpReport.vue?vue&type=template&id=3c9c9024&lang=pug&"
import script from "./AreaGpReport.vue?vue&type=script&lang=ts&"
export * from "./AreaGpReport.vue?vue&type=script&lang=ts&"
import style0 from "./AreaGpReport.vue?vue&type=style&index=0&id=3c9c9024&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports